<script>
import {defineComponent} from 'vue'
import {ElMessage, ElNotification} from "element-plus";
import {API_BASE, API_BASE_CATEGORIES, STATUS_OPTIONS, LANG_TABS, TITLE_LANG_LABELS} from "./constants";

// Admin panel'ning yagona ishlaydigan interfeys tili — hozircha til almashtirgich
// yo'q (StateBudgetList.vue'dagi HL_HEADER konvensiyasiga mos).
const HL_HEADER = {hl: "uz_lat"};

export default defineComponent({
  name: "OpennessOrganizationForm",
  data() {
    return {
      loading: false,
      activeLang: "uz_lat",
      langErrors: [],
      langTabs: LANG_TABS,
      titleLangLabels: TITLE_LANG_LABELS,
      statusOptions: STATUS_OPTIONS,
      categoryOptions: [],
      parentOptions: [],
      parentSearchLoading: false,
      form: {
        id: null,
        parent_id: null,
        category_id: null,
        inn: null,
        order: 0,
        status: "ACTIVE",
        title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null
        }
      },
      rules: {
        inn: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
          {pattern: /^\d{9}$/, message: "INN 9 ta raqamdan iborat bo'lishi kerak", trigger: "blur"},
        ],
        order: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        status: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        title: {
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          ru: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          en: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          kr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        }
      }
    }
  },
  methods: {
    clearLangError(code) {
      this.langErrors = this.langErrors.filter((c) => c !== code);
    },
    getCategoryOptions() {
      this.$http.get(API_BASE_CATEGORIES, {params: {limit: 100}}).then(({data}) => {
        this.categoryOptions = data.data;
      });
    },
    onParentSearch(query) {
      if (!query) {
        this.parentOptions = [];
        return;
      }
      this.parentSearchLoading = true;
      this.$http.get(API_BASE, {params: {search: query, limit: 20}})
          .then(({data}) => {
            this.parentOptions = (data.data || []).filter((org) => org.id !== this.form.id);
          })
          .finally(() => {
            this.parentSearchLoading = false;
          });
    },
    seedParentOption(id) {
      this.$http.get(`${API_BASE}/${id}`).then(({data}) => {
        this.parentOptions = [data];
      });
    },
    getOrganizationById() {
      this.loading = true;
      this.$http.get(`${API_BASE}/${this.form.id}/full`, {headers: HL_HEADER})
          .then(({data}) => {
            this.form.id = data.id;
            this.form.parent_id = data.parent_id;
            this.form.category_id = data.category_id;
            this.form.inn = data.inn;
            this.form.order = data.order;
            this.form.status = data.status;
            this.form.title = {...this.form.title, ...data.title};
            if (this.form.parent_id) {
              this.seedParentOption(this.form.parent_id);
            }
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.langErrors = [];
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            http = this.$http.put(`${API_BASE}/${this.form.id}`, this.form);
          } else {
            http = this.$http.post(API_BASE, this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response?.data?.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        } else {
          ElMessage.error("Iltimos, majburiy maydonlarni to'ldiring");
          if (invalidFields) {
            this.langErrors = Object.keys(invalidFields)
                .filter((key) => key.startsWith("title."))
                .map((key) => key.split(".")[1]);
            const firstInvalidLang = this.langErrors[0];
            if (firstInvalidLang) this.activeLang = firstInvalidLang;
          }
        }
      })
    }
  },
  mounted() {
    this.getCategoryOptions();

    if (this.$route.query.parent) {
      this.form.parent_id = parseInt(this.$route.query.parent);
      this.seedParentOption(this.form.parent_id);
    }

    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getOrganizationById()
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="INN" prop="inn">
                <el-input
                    v-model="form.inn"
                    @input="form.inn = form.inn.replace(/\D/g, '').slice(0, 9)"
                    inputmode="numeric"
                    maxlength="9"
                    placeholder="9 xonali raqam"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tartib raqami" prop="order">
                <el-input-number v-model="form.order" :min="0" style="width: 100%"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Holati" prop="status">
                <el-select v-model="form.status" style="width: 100%">
                  <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Kategoriya" prop="category_id">
                <el-select v-model="form.category_id" clearable style="width: 100%" placeholder="Tanlanmagan">
                  <el-option v-for="opt in categoryOptions" :key="opt.id" :label="opt.title" :value="opt.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Bosh tashkilot" prop="parent_id">
                <el-select
                    v-model="form.parent_id"
                    filterable
                    remote
                    reserve-keyword
                    clearable
                    :remote-method="onParentSearch"
                    :loading="parentSearchLoading"
                    placeholder="INN yoki nomi bo'yicha qidiring"
                    style="width: 100%"
                >
                  <el-option v-for="opt in parentOptions" :key="opt.id" :label="`${opt.title} (${opt.inn})`" :value="opt.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <fieldset class="form-fieldset">
                <legend>Nomi (barcha tillarda)</legend>
                <el-tabs v-model="activeLang" class="lang-tabs">
                  <el-tab-pane v-for="lt in langTabs" :key="lt.code" :name="lt.code">
                    <template #label>
                      <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes(lt.code)}">
                        {{ lt.tabLabel }}
                        <span v-if="!form.title[lt.code]" class="lang-tab-dot" title="Bo'sh"/>
                      </span>
                    </template>
                    <el-form-item :label="titleLangLabels[lt.code]" :prop="'title.' + lt.code">
                      <el-input
                          v-model="form.title[lt.code]"
                          :placeholder="titleLangLabels[lt.code]"
                          clearable
                          @input="clearLangError(lt.code)"
                      />
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </fieldset>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.form-fieldset {
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
  padding: 0 12px 12px;
  margin-bottom: 18px;
}

.form-fieldset legend {
  padding: 0 6px;
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.lang-tabs {
  margin-bottom: 4px;
}

.lang-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.lang-tab-label--error {
  color: #f56c6c;
}

.lang-tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e6a23c;
  flex-shrink: 0;
}
</style>
